import Vue from "vue";
import Vuetify, {VApp, VCard} from "vuetify/lib";
import "vuetify/src/stylus/app.styl";

Vue.use(Vuetify, {
  components: {
    VApp, VCard
  },
  iconfont: "md"
});